webpackJsonp([74],{

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1282);


/***/ }),

/***/ 1282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(177);

var _datetime2 = _interopRequireDefault(_datetime);

var _it = __webpack_require__(792);

var _it2 = _interopRequireDefault(_it);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('it', _it2.default);

/***/ })

},[1281]);


// WEBPACK FOOTER //
// app/datetime.it-1235d9885b9c755d2006.js